import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import { useAuth } from "../../../context/AuthContext";
import { useSubmitAssignmentByAdminQuery } from "../../../api/useSubmitAssignmentByAdmin";
import { useQueryClient } from "@tanstack/react-query";

const AdminAssignmentSubmitDialog = ({
  open,
  onClose,
  currentAssignment,
  studentId,
}) => {
  // State for message and submissionLinks
  const queryClient = useQueryClient();
  const [errorMessage, setErrorMessage] = useState("");
  const [submissionLinks, setSubmissionLinks] = useState(
    currentAssignment?.submissionLinks?.map((link) => ({
      title: link.title,
      detail: link.detail,
      link: "", // 또는 link.link 등 초기 링크 값이 있다면 여기에 설정
    })) || []
  );
  useEffect(() => {
    // currentAssignment가 업데이트될 때마다 submissionLinks 상태도 업데이트
    if (currentAssignment && currentAssignment.submissionLinks) {
      setSubmissionLinks(
        currentAssignment.submissionLinks.map((link) => ({
          title: link.title,
          detail: link.detail,
          link: "", // 또는 link.link 등 초기 링크 값이 있다면 여기에 설정
        }))
      );
    }
  }, [currentAssignment]);

  useEffect(() => {
    setErrorMessage("");
  }, [open]);
  const { mutate: submit, isPending } = useSubmitAssignmentByAdminQuery();
  const handleLinkChange = (index, field, value) => {
    const updatedLinks = submissionLinks.map((link, linkIndex) =>
      index === linkIndex ? { ...link, [field]: value } : link
    );
    setSubmissionLinks(updatedLinks);
  };

  const handleSubmit = () => {
    const data = {
      submissionLinks: submissionLinks,
      message: "",
      studentId: studentId,
    };
    // TODO: Submit 'data' to the server

    submit(
      { data, agendaId: currentAssignment._id },
      {
        onSuccess: () => {
          onClose(); // 성공 시 모달 닫기
          setErrorMessage("");
          queryClient.invalidateQueries("assignment");
        },
        onError: (error) => {
          setErrorMessage(
            error.response.data.message || "등록에 실패했습니다."
          ); // 실패 시 에러 메시지 설정
        },
      }
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="assignment-dialog-title"
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "80%",
          width: "auto",
        },
      }}
    >
      <DialogTitle id="assignment-dialog-title">
        {currentAssignment.assignment}
      </DialogTitle>

      <DialogContent dividers>
        {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
        {submissionLinks &&
          submissionLinks.map((link, index) => (
            <React.Fragment key={index}>
              <Typography variant="subtitle1">{link.title}</Typography>
              <Typography variant="subtitle2" gutterBottom>
                {link.detail}
              </Typography>
              <TextField
                autoFocus
                margin="dense"
                id={`link-${index}`}
                label={link.title}
                type="url"
                fullWidth
                variant="outlined"
                value={submissionLinks[index].link}
                onChange={(e) =>
                  handleLinkChange(index, "link", e.target.value)
                }
                required={true}
              />
            </React.Fragment>
          ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>닫기</Button>
        <Button
          onClick={() => {
            handleSubmit();
          }}
          disabled={isPending}
        >
          {isPending ? "제출중" : "제출하기"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdminAssignmentSubmitDialog;
